<template>
    <div v-if="loading">
        <i class="fa fa-2x fa-spin fa-circle-notch"></i>
    </div>
    <div v-else>
        <div v-if="!Object.keys(presentations).length" class="alert alert-info">
            {{ __('No presentations found') }}
        </div>
        <div class="presentations" v-else>
            <ul class="dates">
                <li v-for="rooms, date in presentations" @click="activeDate = date; initCarousel();" class="clickable" :class="{ active : activeDate == date}">
                    {{ $dayjs(date).format('dddd DD/MM') }}
                </li>
            </ul>
            <div v-if="activeDate">
                <div class="calendar">
                    <ul class="times" ref="times">
                        <li v-for="timeSlot in timeSlots"><span>{{ $dayjs.utc(timeSlot).tz('Europe/Amsterdam').format('HH:mm') }}</span></li>
                    </ul>
                    <div class="nav-placeholder" ref="placeholder" :style="{ marginTop: padding +'px' }"></div>
                    <div id="presentationCarousel" class="owl-carousel">
                        <div v-for="presentations, roomId in visiblePresentations" class="list">
                            <div class="room-header" :style="{ top : padding +'px' }">
                                <div>
                                    <span>{{ presentations[0].room.name[_locale] }}</span>
                                    <span v-if="presentations[0].room?.subname?.[_locale]" class="text-muted small text-nowrap">
                                        ({{ presentations[0].room?.subname?.[_locale] }})
                                    </span>
                                </div>
                            </div>
                            <div class="position-relative" :ref="'room-'+ roomId">
                                <presentation :presentation="presentation" :hour-height="hourHeight" :start-and-end-time="startAndEndTime" v-for="presentation in presentations" :key="presentation.id"></presentation>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span class="nav nav-prev" :style="{ paddingTop : (padding + 95) +'px'}" v-if="showPrev" @click="owl.trigger('prev.owl.carousel')">
                <button class="btn btn-outline-secondary"><i class="fa fa-chevron-left fa-fw ms-0"></i></button>
            </span>
            <span class="nav nav-next" :style="{ paddingTop : (padding + 95) +'px'}" v-if="showNext" @click="owl.trigger('next.owl.carousel')">
                <button class="btn btn-outline-secondary"><i class="fa fa-chevron-right fa-fw ms-0"></i></button>
            </span>
        </div>
    </div>
</template>

<script>
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

export default {
    props: ['locale'],
    data() {
        return {
            loading : true,
            presentations: null,
            activeDate: null,
            hourHeight: 210,
            owl : null,
            currentIndex : 0,
            padding: 0,
            scrollTimeout : null,
        }
    },
    methods: {
        loadPresentations() {
            axios.get('/'+ this.locale +'/presentations')
                 .then(response => {
                     this.presentations = response.data;
                     this.loading = false;
                     Vue.nextTick(() => {
                         this.setActiveDate();
                     })
                 });
        },
        setActiveDate() {
            if (!this.presentations) {
                return;
            }

            let activeDate = localStorage.getItem('selected-presentation-date');

            if (!activeDate || (activeDate && !this.presentations[activeDate])) {
                activeDate = Object.keys(this.presentations)[0];
            }

            this.activeDate = activeDate;
        },
        async initCarousel() {
            if (this.owl) {
                this.owl.trigger('destroy.owl.carousel');
            }

            Vue.nextTick(() => {
                this.owl = jQuery('#presentationCarousel').owlCarousel({
                    margin: 15,
                    items: Math.min(this.roomIds.length, 4),
                    stagePadding: 30,
                });

                this.owl.on('changed.owl.carousel', (data) => {
                    this.currentIndex = data.item.index;
                });
            })
        },
        setHeights() {
            let targetHeight = jQuery(this.$refs.times).height();
            for (const key in this.$refs) {
                if (key.includes('room-')) {
                    jQuery(this.$refs[key]).height(targetHeight);
                }
            }
        },
        handleScroll(event) {
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout)
            }

            this.scrollTimeout = setTimeout(() => {
                let difference = this.$refs.times.getBoundingClientRect().top - 65 - 50;

                if (difference < 0) {
                    this.padding = difference * -1;
                } else {
                    this.padding = 0;
                }
            }, 100);
        }
    },
    computed: {
        visiblePresentations() {
            if (!this.activeDate) {
                return null;
            }
            if (!this.presentations) {
                return null;
            }

            let sortable = [];
            for (var roomId in this.presentations[this.activeDate]) {
                sortable.push(['room-'+ roomId, this.presentations[this.activeDate][roomId]]);
            }

            sortable.sort((a,b) => {
                return a[1][0].room.order_id < b[1][0].room.order_id ? -1 : 1;
            });

            let visiblePresentations = {};

            sortable.forEach(function(item){
                visiblePresentations[item[0]]=item[1];
            })

            return visiblePresentations;
        },
        startAndEndTime() {
            var times = { start : null, end : null}

            for (const key in this.visiblePresentations) {
                this.visiblePresentations[key].forEach(presentation => {
                    let startTime = this.$dayjs(presentation.starts_at);
                    let endTime = this.$dayjs(presentation.ends_at);

                    if (!times.start || startTime < times.start) {
                        times.start = startTime;
                    }

                    if (!times.end || endTime > times.end) {
                        times.end = endTime;
                    }
                });
            }

            return times;
        },
        timeSlots() {
            if (!this.startAndEndTime) {
                return [];
            }

            var time = this.startAndEndTime.start.minute(this.startAndEndTime.start.minute() < 30 ? 0 : 30).second(0);

            var times = [];
            while (time < this.startAndEndTime.end) {
                times.push(time);
                time = time.add(30, 'minute');
            }

            return times;
        },
        roomIds() {
            if (!this.visiblePresentations || this.visiblePresentations.length == 0) {
                return [];
            }

            return Object.keys(this.visiblePresentations);
        },
        showNext() {
            return this.currentIndex + 5 <= this.roomIds.length;
        },
        showPrev() {
            return this.currentIndex > 0;
        },
    },
    watch: {
        activeDate() {
            localStorage.setItem('selected-presentation-date', this.activeDate);

            this.initCarousel()
                .then(() => {
                    this.setHeights();
                });
        }
    },
    mounted() {
        this.$dayjs.locale(this._locale);
        this.$dayjs.extend(utc);
        this.$dayjs.extend(timezone);
        this.loadPresentations();

        window.addEventListener('scroll', this.handleScroll);
    }
}
</script>
